// THD Orange
const orangePrimaryColor = '#F96302';
//Lighter orange
const orangeSecondaryColor = '#FFE5D5';

export const orangeTheme = {
   primaryButton: orangePrimaryColor,
   primaryButtonHover: '#F97A27',

   clusterOuter: orangePrimaryColor,
   clusterInner: orangeSecondaryColor,
   hotspotInner: orangePrimaryColor,
   hotspotOuter: orangeSecondaryColor,
};
